import React, { useState } from "react";
import { Modal } from '@themesberg/react-bootstrap';
import { Button, Form, Input, Select } from "antd";
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
import { Editor } from "react-draft-wysiwyg";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import { convertToRaw, EditorState } from "draft-js";
import { settingAlert, settingResponse } from "../../../states/settings";
import { createHowItWorkModal, editHowItWorkModal, editHowItWorkVal, howItWorkEditor, howItWorkRefresh } from "../../../states/howItWork";
import { createFaq, createHowItWork, updateFaq, updateHowItWork } from "../../../services/apiCalls";
import { getHtml } from "../../../services/utilities";
import { createFaqModal, editFaqModal, editFaqVal, faqEditor, faqRefresh } from "../../../states/faqs";

const HowItWorkModal = () => {
  const [loading, setLoading] = useState(false)
  const setShowAlert = useSetRecoilState(settingAlert);
  const setResponse = useSetRecoilState(settingResponse)
  const setRefresh = useSetRecoilState(faqRefresh)
  const [showModal, setShowModal] = useRecoilState(createFaqModal);
  const [form] = Form.useForm()
  const [editor, setEditor] = useState("")
  const [editorState, setEditorState] = useState(EditorState.createEmpty());


  const [text, setText] = useState();
  /*const onEditorStateChange = function (editorState) {
    setEditorState(editorState);
    const { blocks } = convertToRaw(editorState.getCurrentContent());
    /*let text = blocks.reduce((acc, item) => {
      acc = acc + item.text;
      return acc;
    }, "");*//*
    let text = editorState.getCurrentContent().getPlainText("\u0001");
    setText(text);
  };*/
  const onEditorStateChange = editorState => {
    setEditor(editorState);
  };
  const handleSubmit = async (val) => {
    const date = new Date()
    setLoading(true)
    const d = {
      title: val.title,
      content: getHtml(editor),
      type: val.type
    }
    const res = await createFaq(d)
    if (res.status) {
      setResponse({ message: res.message, title: "success" })
      setShowAlert(true)
      setRefresh(date.toTimeString())
      setShowModal(false)
      form.resetFields()
    } else {
      setResponse({ message: res.message || res, title: "failed" })
      setShowAlert(true)
    }
    setLoading(false)
  }
  return (
    <Modal as={Modal.Dialog} centered show={showModal} onHide={() => setShowModal(false)}>
      <Modal.Header>
        <Modal.Title className="h6">Create New FAQs</Modal.Title>
        <Button variant="close" aria-label="Close" onClick={() => setShowModal(false)} />
      </Modal.Header>
      <Modal.Body>
        <Form form={form} layout="vertical" onFinish={handleSubmit}>
          <Form.Item label="Title" name="title" rules={[{ required: true }]}>
            <Input />
          </Form.Item>
          <Form.Item label="Description" name="content" rules={[{ required: true }]}>
            <Editor
              editorState={editor}
              editorClassName="px-3 border border-gray-1"
              editorStyle={{
                height: 200,
                overflow: 'auto',
              }}
              onEditorStateChange={onEditorStateChange}
            />      
          </Form.Item>
          <Form.Item label="Type" name="type">
            <Select>
              <Select.Option key='1' value="merchant">Merchant</Select.Option>
              <Select.Option key='2' value="agent">Agent</Select.Option>
              <Select.Option key='3' value="aggregator">Aggregator</Select.Option>
            </Select>
          </Form.Item>
          <Form.Item>
            <Button type="primary" htmlType="submit" loading={loading}>
              Submit
            </Button>
          </Form.Item>
        </Form>
      </Modal.Body>
    </Modal>
  )
}
export default HowItWorkModal

export const EditModal = () => {
  const [loading, setLoading] = useState(false)
  const setShowAlert = useSetRecoilState(settingAlert);
  const setResponse = useSetRecoilState(settingResponse)
  const setRefresh = useSetRecoilState(faqRefresh)
  const value = useRecoilValue(editFaqVal)
  const [showModal, setShowModal] = useRecoilState(editFaqModal);
  const [form] = Form.useForm()
  const [editor, setEditor] = useRecoilState(faqEditor)
  // form.setFieldsValue({ title: value.title, id: value.id, position: value.position })

  const handleSubmit = async (val) => {
    const date = new Date()
    setLoading(true)
    const d = {
      title: val.title,
      content: getHtml(editor),
      // type: val.type,
      id: val.id
    }
    const res = await updateFaq({ data: d, id: val.id })
    if (res.status) {
      setResponse({ message: res.message, title: "success" })
      setShowAlert(true)
      setRefresh(date.toTimeString())
      setShowModal(false)
      form.resetFields()
    } else {
      setResponse({ message: res.message || res, title: "failed" })
      setShowAlert(true)
    }
    setLoading(false)
  }
  const onEditorStateChange = editorState => {
    setEditor(editorState);
  };
  return (
    <Modal as={Modal.Dialog} centered show={showModal} onHide={() => setShowModal(false)}>
      <Modal.Header>
        <Modal.Title className="h6">Update FAQs</Modal.Title>
        <Button variant="close" aria-label="Close" onClick={() => setShowModal(false)} />
      </Modal.Header>
      <Modal.Body>
        <Form form={form} layout="vertical" onFinish={handleSubmit}>
          <Form.Item initialValue={value.title} label="Title" name="title" rules={[{ required: true }]}>
            <Input />
          </Form.Item>
          <Form.Item initialValue={value.id} hidden name="id">
            <Input />
          </Form.Item>
          <Form.Item initialValue={value.content} label="Description" name="content" rules={[{ required: true }]}>
            <Editor
              editorState={editor}
              editorClassName="px-3 border border-gray-1"
              editorStyle={{
                height: 200,
                overflow: 'auto',
              }}
              onEditorStateChange={onEditorStateChange}
            />
          </Form.Item>
          {/* <Form.Item initialValue={value.position} label="Position" name="position" rules={[{ required: true }]}>
            <Input />
          </Form.Item> */}
          <Form.Item>
            <Button type="primary" htmlType="submit" loading={loading}>
              Update
            </Button>
          </Form.Item>
        </Form>
      </Modal.Body>
    </Modal>
  )
}